import { render, staticRenderFns } from "./RuleManagerPiExactMatchRules.vue?vue&type=template&id=a71a8f36&scoped=true&"
import script from "./RuleManagerPiExactMatchRules.vue?vue&type=script&lang=js&"
export * from "./RuleManagerPiExactMatchRules.vue?vue&type=script&lang=js&"
import style0 from "./RuleManagerPiExactMatchRules.vue?vue&type=style&index=0&id=a71a8f36&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71a8f36",
  null
  
)

export default component.exports